import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './Card.module.css';

function Card({ children, noShadow = false }) {
  return (
    <div
      className={cx(styles.card, {
        [styles.noCardShadow]: noShadow,
      })}
    >
      {children}
    </div>
  );
}

function CardHeader({ children }) {
  return <div className={styles.cardHeader}>{children}</div>;
}

function CardSubHeader({ children }) {
  return <div className={styles.cardSubHeader}>{children}</div>;
}

function CardBody({ children }) {
  return <div className={styles.cardBody}>{children}</div>;
}

Card.propTypes = {
  children: PropTypes.node.isRequired,
  noShadow: PropTypes.bool,
};

CardHeader.propTypes = {
  children: PropTypes.node.isRequired,
};

CardBody.propTypes = {
  children: PropTypes.node.isRequired,
};

CardSubHeader.propTypes = {
  children: PropTypes.node.isRequired,
};

export { Card, CardHeader, CardBody, CardSubHeader };
